/** @owner @Appboy/ai-decisioning-experience */

import { decisioningCreativeComponentTag } from "./constants";
import type { DecisioningCreativeComponentName } from "./types";

/**
 * Generates the liquid tag for a decisioning creative component name.
 * @param name - The decisioning creative component name
 * @return The liquid tag string (e.g., `{% decisioning_creative_component cta %}`)
 */
export const buildDecisioningCreativeComponentTag = (
  name: DecisioningCreativeComponentName | null | undefined
): string => {
  if (!name) {
    return "";
  }
  return `{% ${decisioningCreativeComponentTag} ${name} %}`;
};
